import { useSelector } from "react-redux";
import { useLocation, Navigate, Outlet } from "react-router-dom"


const ProtectedGradingTool = ({isLoggedin}) => {

    const location = useLocation()
    const loggedInUser = useSelector((state) => JSON.parse(localStorage.getItem("user")));

    return (
        isLoggedin && loggedInUser?.userData?.user_options?.grading_tool_available
            ? <Outlet />
            : <Navigate to="/" state={{ from: location }} replace />
    )
}
export default ProtectedGradingTool